import React from 'react';
import beinsports from '../assets/chaine/Bein_Sports.png'
import Atresplayer from '../assets/chaine/AXN_logo.png'
import netflix from '../assets/chaine/Netflix.png'
import primevideo from '../assets/chaine/Prime_Video.png'
import disney from '../assets/chaine/Disney+.png'
import movistarplus from '../assets/chaine/Canais-TVCine-2020.jpg'
import tf1 from '../assets/chaine/Canal_Hollywood.png'
import hbomax from '../assets/chaine/HBO_Max.png'
import w9 from '../assets/chaine/Logo_Eleven_Sports_2020.png'
import ocs from '../assets/chaine/SIC_logo_2018.png'
import plutotv from '../assets/chaine/Filmbox.png'
import appletvplus from '../assets/chaine/Apple_TV.png'
import rmcsport from '../assets/chaine/ESPN.png'
import m6 from '../assets/chaine/Pluto_TV.png'
import tf1seriesfilms from '../assets/chaine/SkyShowtime_Logo.png'
import hulu from '../assets/chaine/Hulu.png'
import arte from '../assets/chaine/Discovery.png'
import Rakuten_TV from '../assets/chaine/Logótipo_TVI.png'
import SportTV from '../assets/chaine/Logo_SportTV.svg.webp'

import film1 from '../assets/film/1.webp'
import film2 from '../assets/film/2.webp'
import film3 from '../assets/film/3.webp'
import film4 from '../assets/film/4.webp'
import film5 from '../assets/film/5.webp'
import film6 from '../assets/film/6.webp'
import film7 from '../assets/film/7.webp'
import film8 from '../assets/film/8.jpg'
import film9 from '../assets/film/9.webp'
import film10 from '../assets/film/10.webp'
import film11 from '../assets/film/11.webp'
import film12 from '../assets/film/12.webp'
import film13 from '../assets/film/13.webp'
import film14 from '../assets/film/14.webp'
import film15 from '../assets/film/15.webp'
import film16 from '../assets/film/16.webp'
import film17 from '../assets/film/17.webp'
import film18 from '../assets/film/18.webp'
import film19 from '../assets/film/19.jpg'
import film20 from '../assets/film/20.webp'
import film21 from '../assets/film/21.webp'
import film22 from '../assets/film/22.webp'
import film23 from '../assets/film/23.webp'
import film24 from '../assets/film/24.webp'
import film25 from '../assets/film/25.webp'
import film26 from '../assets/film/26.webp'
import film27 from '../assets/film/27.webp'
import film28 from '../assets/film/28.webp'
import film29 from '../assets/film/29.webp'
import film30 from '../assets/film/30.webp'
import film31 from '../assets/film/31.webp'
import film32 from '../assets/film/32.webp'
import film33 from '../assets/film/33.webp'
import film34 from '../assets/film/34.webp'
import film35 from '../assets/film/35.webp'
import film36 from '../assets/film/36.webp'
import film37 from '../assets/film/37.webp'
import film38 from '../assets/film/38.webp'

export default function Series(){

    // Channel logos data
    const channels = [
        { name: "Netflix", logo: netflix },
        { name: "Disney+", logo: disney },
        { name: "Bein Sports", logo: beinsports },
        { name: "Prime Video", logo: primevideo },
        { name: "HBO Max", logo: hbomax },
        { name: "Apple TV", logo: appletvplus },
        { name: "Hulu", logo: hulu },
        { name: "SkyShowtime", logo: tf1seriesfilms },
        { name: "RTVE", logo: ocs },
        { name: "Cuatro", logo: w9 },
        { name: "Antena3", logo: tf1 },
        { name: "Atresplayer", logo: Atresplayer },
        { name: "art", logo: arte },
        { name: "Pluto TV", logo: plutotv },
        { name: "ESPN", logo: rmcsport },
        { name: "Rakuten TV", logo: Rakuten_TV },
        { name: "M6", logo: m6 },
        { name: "Movistar Plus", logo: movistarplus },
        { name: "SportTV", logo: SportTV }
    ];

    // Film posters data
    const films = [
        { id: 1,  poster: film1 },
        { id: 2, poster: film2 },
        { id: 3, poster: film3 },
        { id: 4, poster: film4 },
        { id: 5, poster: film5 },
        { id: 6, poster: film6 },
        { id: 7, poster: film7 },
        { id: 8, poster: film8 },
        { id: 9, poster: film9 },
        { id: 10, poster: film10 },
        { id: 11, poster: film11 },
        { id: 12, poster: film12 },
        { id: 13, poster: film13 },
        { id: 14, poster: film14 },
        { id: 15, poster: film15 },
        { id: 16, poster: film16 },
        { id: 17, poster: film17 },
        { id: 18, poster: film18 },
        { id: 19, poster: film19 },
        { id: 20, poster: film20 },
        { id: 21, poster: film21 },
        { id: 22, poster: film22 },
        { id: 23, poster: film23 },
        { id: 24, poster: film24 },
        { id: 25, poster: film25 },
        { id: 26, poster: film26 },
        { id: 27, poster: film27 },
        { id: 28, poster: film28 },
        { id: 29, poster: film29 },
        { id: 30, poster: film30 },
        { id: 31, poster: film31 },
        { id: 32, poster: film32 },
        { id: 33, poster: film33 },
        { id: 34, poster: film34 },
        { id: 35, poster: film35 },
        { id: 36, poster: film36 },
        { id: 37, poster: film37 },
        { id: 38, poster: film38 },
    ];


    return(
        <>
        <section className="series-section relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
            <div className="text-center mt-12">
                <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                Transmissão ilimitada dos filmes mais recentes, séries e canais de TV em direto
                </h1>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Desfruta de conteúdo premium das melhores plataformas de streaming numa única subscrição
                </p>
            </div>
            {/* Films Carousel - Left to Right */}
            <div className="mt-5">
                <div className="relative overflow-hidden">
                    <div className="flex space-x-6 pb-5 carousel-films">
                        {[...films, ...films, ...films].map((film, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 carousel-item">
                                <div className="relative w-48 h-80 rounded-lg overflow-hidden shadow-lg">
                                    <img 
                                        src={film.poster}
                                        alt={film.id}
                                        className="w-full h-full object-cover carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Channels Carousel - Right to Left */}
            <div className="mt-5"> 
                <div className="relative overflow-hidden">
                    <div className="flex space-x-8 carousel-channels">
                        {[...channels, ...channels, ...channels].map((channel, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 flex items-center justify-center carousel-item">
                                <div className="w-24 h-16 flex items-center justify-center p-2">
                                    <img 
                                        src={channel.logo} 
                                        alt={channel.name}
                                        className="max-w-full max-h-full object-contain carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            </div>
        </section>
        </>
    )
}